import Type from '../type';

export default class WeakRefMap<K, V extends WeakKey>
{
	#refs: Map<K, WeakRef<V>> = new Map();
	#registry: FinalizationRegistry<K>;

	constructor()
	{
		this.#registry = new FinalizationRegistry(this.#cleanupCallback.bind(this));
	}

	clear(): void
	{
		this.#refs.forEach((ref) => {
			const value = ref.deref();
			if (!Type.isUndefined(value))
			{
				this.#registry.unregister(value);
			}
		});

		this.#refs.clear();
	}

	delete(key: K): boolean
	{
		const value = this.get(key);
		if (!Type.isUndefined(value))
		{
			this.#registry.unregister(value);
		}

		return this.#refs.delete(key);
	}

	get(key: K): V | undefined
	{
		return this.#refs.get(key)?.deref();
	}

	has(key: K): boolean
	{
		return !Type.isUndefined(this.#refs.get(key)?.deref());
	}

	set(key: K, value: V): this
	{
		this.#refs.set(key, new WeakRef(value));
		this.#registry.register(value, key, value);

		return this;
	}

	#cleanupCallback(key: K): void
	{
		const ref = this.#refs.get(key);
		if (ref && !ref.deref())
		{
			this.#refs.delete(key);
		}
	}
}
